import { render, staticRenderFns } from "./VisualizzaDisegno.vue?vue&type=template&id=1588a107&scoped=true&"
import script from "./VisualizzaDisegno.vue?vue&type=script&lang=js&"
export * from "./VisualizzaDisegno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1588a107",
  null
  
)

export default component.exports